window.csT=window.csT||function(k,d){return (window.csI18n&&window.csI18n[k])||d;};
/* Clightstore collection pagination: 15 products per page, on top of the client-side filters.
   The page number lives in ?p= (NOT ?page=): Shopify's own server-side pagination also reads ?page=,
   so a refresh on ?page=6 asked Shopify for page 6 of a 250-per-page list and rendered an empty grid. */
(() => {
  const root = document.querySelector('[data-csc]'); if (!root) return;
  const grid = root.querySelector('[data-csc-grid]'); if (!grid) return;
  const PER = 15;
  const qs = new URLSearchParams(location.search);
  /* old links / bookmarks with ?page=N: move the number to ?p=N and reload once so Shopify renders all products */
  if (qs.has('page')) {
    const n = parseInt(qs.get('page'), 10);
    qs.delete('page');
    if (n > 1) qs.set('p', n);
    const q = qs.toString();
    location.replace(location.pathname + (q ? '?' + q : '') + location.hash);
    return;
  }
  let page = Math.max(1, parseInt(qs.get('p'), 10) || 1);
  const old = root.querySelector('.csc__pag'); if (old) old.remove();
  const nav = document.createElement('nav'); nav.className = 'csc__pager'; nav.setAttribute('aria-label', (csT('pagination',(csT('pagination',"Pagination"))))); nav.hidden = true;
  grid.after(nav);
  const visible = () => [...grid.querySelectorAll('[data-csc-item]')].filter(el => !el.hidden);
  /* which products are shown and in which order: only when this changes (filter or sort) do we go back to page 1 */
  const sigOf = () => visible().map(el => el.dataset.i).join(',');
  let sig = '';
  const b = (label, p, opts = {}) => `<button type="button" data-p="${p}"${opts.cur ? ' aria-current="page"' : ''}${opts.dis ? ' disabled' : ''}${opts.aria ? ` aria-label="${opts.aria}"` : ''}>${label}</button>`;
  function render(pages) {
    if (pages < 2) { nav.hidden = true; nav.innerHTML = ''; return; }
    nav.hidden = false;
    const set = new Set([1, pages, page - 1, page, page + 1].filter(n => n >= 1 && n <= pages));
    const nums = [...set].sort((a, c) => a - c);
    let html = b('&lsaquo;', page - 1, { dis: page === 1, aria: (csT('previous_page',(csT('previous_page',"Previous page")))) }), last = 0;
    nums.forEach(n => { if (n - last > 1) html += '<span aria-hidden="true">&hellip;</span>'; html += b(n, n, { cur: n === page, aria: `Page ${n}` }); last = n; });
    html += b('&rsaquo;', page + 1, { dis: page === pages, aria: (csT('next_page',(csT('next_page',"Next page")))) });
    nav.innerHTML = html;
  }
  function apply(scroll) {
    const vis = visible();
    const pages = Math.max(1, Math.ceil(vis.length / PER));
    if (page > pages) page = pages;
    grid.querySelectorAll('.is-pg-off').forEach(el => el.classList.remove('is-pg-off'));
    vis.forEach((el, i) => { if (i < (page - 1) * PER || i >= page * PER) el.classList.add('is-pg-off'); });
    render(pages);
    const p = new URLSearchParams(location.search);
    p.delete('page');
    page > 1 ? p.set('p', page) : p.delete('p');
    const q = p.toString(); history.replaceState(history.state, '', location.pathname + (q ? '?' + q : '') + location.hash);
    if (scroll) (root.querySelector('.csc__bar') || grid).scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  nav.addEventListener('click', e => { const t = e.target.closest('button[data-p]'); if (!t || t.disabled) return; page = +t.dataset.p; apply(true); });
  let queued = false;
  /* price updates (volume discounts refresh every few seconds) also change the grid; those must not reset the page */
  const mo = new MutationObserver(() => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; const s = sigOf(); if (s === sig) return; sig = s; page = 1; apply(false); }); });
  const start = () => { apply(false); sig = sigOf(); mo.observe(grid, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] }); };
  document.readyState === 'complete' ? start() : window.addEventListener('load', start);
})();
